import { z } from "zod/v4-mini";

import { TandemEventDefinition } from "@/lib/drivers/tandem/TandemTypes";

export type TimeChangePayload = {
  time_prior: number;
  time_after: number;
};

export type TimeChangeEvent = {
  timePrior: number;
  timeAfter: number;
  timeDeltaMs: number;
};

const timeChangeSchema = z.object({
  time_prior: z.number(),
  time_after: z.number(),
});

export const LID_TIME_CHANGED = {
  value: 0x0d,
  name: "Time Change Event",
  format: "ii........",
  fields: ["time_prior", "time_after"],
  postprocess: rec => ({
    timePrior: rec.time_prior,
    timeAfter: rec.time_after,
    timeDeltaMs: rec.time_after - rec.time_prior,
  }),
  schema: timeChangeSchema,
} as const satisfies TandemEventDefinition<TimeChangePayload, TimeChangeEvent>;
